import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import MobileMenu from '../MobileMenu/MobileMenu'
import HeaderTopbar from '../HeaderTopbar/HeaderTopbar'
import Logo from '../../images/Logo.png'
import company from '../../images/company-profile.pdf'


const Header = (props) => {
   const [menuActive, setMenuState] = useState(false);

    const SubmitHandler = (e) => {
        e.preventDefault()
    } 

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }


    return (
        <header id="header" className={props.hclass}>
            <HeaderTopbar />
            <div className="wpo-site-header">
                <nav className="navigation navbar navbar-expand-lg navbar-light">
                    <div className="container">
                        <div className="row align-items-center">
                        <div className="col-lg-2 col-md-5 col-6">
                                <div className="navbar-header">
                                    <Link onClick={ClickHandler} className="navbar-brand" to="/"><img src={Logo}
                                        alt="" /></Link>
                                </div>
                            </div>
                            <div className="col-lg-1 col-md-2 col-3 d-lg-none dl-block">
                                <div className="mobail-menu">
                                    <MobileMenu />
                                </div>
                            </div>
                            
                            <div className="col-lg-8 col-md-1 col-1">
                                <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                    <button className="menu-close"><i className="ti-close"></i></button>
                                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                                        <li>
                                            <Link onClick={ClickHandler} to="/">Home</Link>
                                           
                                        </li>
                                        <li><Link onClick={ClickHandler} to="/about2">About Us</Link></li>
                                        <li className="menu-item-has-children">
                                        <Link onClick={ClickHandler} to="">Our Services</Link>
                                        <ul className='sub-menu'>
                                        <li><Link onClick={ClickHandler} to="/homeinteriors">Home Interiors</Link></li>
                                        <li><Link onClick={ClickHandler} to="/commercialinteriors">Commercial Interiors</Link></li>
                                        <li><Link onClick={ClickHandler} to="/officeinteriors">Office Interiors</Link></li>
                                        <li><Link onClick={ClickHandler} to="/electricallighting">Electrical & Lighting Solutions</Link></li>
                                        <li><Link onClick={ClickHandler} to="/paintingwork">Painting Works</Link></li>
                                        <li><Link onClick={ClickHandler} to="/plumbingwork">Plumbing Works</Link></li>
                                        <li><Link onClick={ClickHandler} to="/renovationwork">Renovation Works</Link></li>
                                        <li><Link onClick={ClickHandler} to="/Carpentryworks">Carpentry Works</Link></li>

                                        </ul>
                                        </li>
                                        
                                        
                                       <li><Link onClick={ClickHandler} to="/gallery">Gallery</Link></li>
                                        <li><Link onClick={ClickHandler} to="/contact">Contact</Link></li>
<li>
  <a href="/company-profile.pdf" target="_blank" rel="noopener noreferrer">
    Company Profile
  </a>
</li>                                    </ul>

                                </div>
                            </div>
                            <div className="col-lg-2 col-md-4 col-2">
                                <div className="header-right">
                                    

                                    <div className="close-form">
                                    {/**<Link onClick={ClickHandler} className="theme-btn" to="tel:9663222146">BOOKING NOW</Link>
 */}
                                        <a href='tel:9663222146' className='theme-btn'>BOOKING NOW</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )
}

export default Header;